{
  "name": "@mcpjam/cli",
  "version": "3.15.2",
  "description": "Test, debug, and validate MCP servers — health checks, OAuth conformance, tool-surface diffing, and structured triage from the terminal or CI",
  "type": "module",
  "main": "dist/index.js",
  "files": [
    "dist"
  ],
  "bin": {
    "mcpjam": "dist/index.js"
  },
  "scripts": {
    "build": "tsup",
    "test": "tsx --test tests/**/*.test.ts",
    "typecheck": "tsc --noEmit",
    "prepublishOnly": "npm run build"
  },
  "dependencies": {
    "@mcpjam/sdk": "^2.0.0",
    "@modelcontextprotocol/server": "2.0.0-beta.4",
    "commander": "^12.1.0",
    "posthog-node": "^5.24.10",
    "ws": "^8.18.0",
    "zod": "^4.1.12"
  },
  "devDependencies": {
    "@modelcontextprotocol/client": "2.0.0-beta.4",
    "@types/node": "^24.0.0",
    "@types/ws": "^8.18.1",
    "tsup": "^8.3.5",
    "tsx": "^4.19.2",
    "typescript": "^5.8.3"
  },
  "keywords": [
    "mcp",
    "model-context-protocol",
    "oauth",
    "conformance",
    "cli",
    "testing",
    "debugging",
    "health-check",
    "ci"
  ],
  "engines": {
    "node": ">=20.0.0"
  }
}
